<template>
  <div>
    <carousel></carousel>
    <b-container fluid class="bg-light h-100 mb-5">
      <b-row>
        <b-col>
          <b-container>
            <b-row id="teaser">
                <b-col sm="4" class="text-center">
                  <img class="rounded-circle mv-rounded-circle" src="../../assets/images/mv/img1.jpg" alt="tenerife" width="140" height="140">
                   <h3 v-translate>About Tenerife</h3>
                   <p v-translate>Tenerife is considered to be the island of "eternal spring" with a gentle climate throughout the year. It is the tallest island of the seven Canary Islands due to the Teide volcano, which is 3718 meters high, being the highest peak of Spain.
                   Tenerife is the place where you can be at the highest height in Spain surrounded by snow and two hours later to tan to the beach.</p>
                </b-col>
                <b-col sm="4" class="text-center">
                  <img class="rounded-circle mv-rounded-circle" src="../../assets/images/mv/grancanaria.jpg" alt="gran canaria" width="140" height="140">
                   <h3 v-translate>About Gran Canaria</h3>
                   <p v-translate>If you let go of your imagination during your visit to Gran Canaria, you will have the feeling that instead of an island, you will actually visit three continents: Africa, Europe and America. It is the third largest island in the Canary Archipelago.
                      One of the main attractions of the island of Gran Canaria is the Maspalomas sand dunes.</p>
                </b-col>
                <b-col sm="4" class="text-center">
                  <img class="rounded-circle mv-rounded-circle" src="../../assets/images/mv/img2.jpg" alt="mario-viajes" width="140" height="140">
                   <h3 v-translate>The other Canary Islands</h3>
                   <p v-translate>La Gomera, Lanzarote, Fuerteventura, La Palma and El Hierro are not just names. They are 5 beautiful and worthwhile islands to visit. Each has different features: La Gomera is considered to be the last jungle in Europe.
                      La Palma is the greenest. El Hierro is the smallest. Lanzarote is preferred by water sports enthusiasts and Fuerteventura is just 100 kilometers away from the African coast and is famous for its beautiful white sandy beaches..</p>
                </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="pt-4 pt-sm-0">
                <hr class="d-none d-sm-block">
                <h2>MARIO VIAJES <span class="float-right"><i v-translate class="d-none d-sm-block">About us</i></span></h2>
                <p class="lead" v-translate>A perfect holiday is the one you wish not to end!</p>
                <hr>
              </b-col>
              <b-col sm="7" class="d-flex align-items-center">
                <div>
                  <p v-translate>With the aid of our proficiency in quality tourism and also, of the years spent in the Canary Islands, we can guarantee you an unforgettable holiday.</p>
                  <p> <translate>Mario Viajes SLU is a young company, developed from our desire to provide the tourists with responsible help and accurate information.</translate><br>
                    <translate>The readiness, sobriety and the dedication which we set into our service, permit us to guarantee to our clients a memorable holiday.</translate><br>
                    <translate>We are here to listen to your wishes and organize your much dreamed vacation! We offer individual and group touristic services for any of the 7 islands of the Canary Archipelago. We are waiting to write together the story of an ideal holiday!</translate>
                  </p>
                </div>
              </b-col>
              <b-col sm="5">
                <img class="img-thumbnail" src="../../assets/images/mv/about-us.jpg" alt="mario viajes - about us">
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <hr>
                <h2>MARIO VIAJES <span class="float-right"><i v-translate class="d-none d-sm-block">What we offer</i></span></h2>
                <p class="lead" v-translate>We are here to turn your holiday into a memorable experience</p>
                <hr>
              </b-col>
              <b-col sm="7" class="d-flex align-items-center">
                <div>
                  <ul>
                    <li v-translate>Full individual, group or tailor-made holidays packages, adapted to all budgets</li>
                    <li><translate>We organise</translate> <b v-translate>MICE</b> <translate>events</translate></li>
                    <li v-translate>Touristic assistance in different languages</li>
                    <li v-translate>Private or group local transfers</li>
                    <li v-translate>On site excursions</li>
                    <li v-translate>Rent a car</li>
                  </ul>
                  <p><translate>We can help you even if you are planning a unique event! And for our partner tourism agencies we developed an online reservation system which facilitates the searches within our products, so we invite you to access our link:</translate> <a href="" data-toggle="modal" data-target="#myModalB2b">b2b.marioviajes.com</a>.</p>
                </div>
              </b-col>
              <b-col sm="5">
                <img class="img-thumbnail" src="../../assets/images/mv/exc.jpg" alt="mario viajes - about us">
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import carousel from './shared/components/carousel'

export default {
  components: { carousel }
}
</script>
